var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;



// WEBPACK FOOTER //
// ./~/function-bind/index.js